/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".account-value-link[_ngcontent-%COMP%]{display:inline-flex;display:-webkit-inline-flex}pru-tooltip[_ngcontent-%COMP%]{padding-top:.2rem}a[href][_ngcontent-%COMP%]{cursor:pointer}.nudge-msg[_ngcontent-%COMP%]{background-color:#f6fbfe;padding:1.5rem;border:1px solid #d6efff;border-radius:5px}.nudge-msg[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}@media (min-width:992px){.nudge-msg[_ngcontent-%COMP%]   .cta-rt[_ngcontent-%COMP%]{text-align:right}}"];
export { styles as styles };
